import script from "./InviteSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteSelect.vue?vue&type=script&setup=true&lang=js"

import "./InviteSelect.vue?vue&type=style&index=0&id=23d5789d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d5789d"]])

export default __exports__